<div class="wrap">
  <!-- <ngx-simplebar data-simplebar-auto-hide="true"> -->
  <div class="ffv_img" [routerLink]="['/home']" routerLinkActive="router-link-active">
    <img src="/assets/img/icon-white/logoFFV_White.svg" alt="logo_FFV">
  </div>
  <div class="name" *ngIf="isConnect">Bienvenue <span>{{name}}</span></div>
  <div class="logIn_logOut" [routerLink]="['/login']" routerLinkActive="router-link-active" *ngIf="!isConnect">
    Connectez-vous pour accéder à votre contenu !
  </div>
  <div class="logIn_logOut" *ngIf="isConnect" (click)="logout()">
    <fa-icon [icon]="faSignOutAlt"></fa-icon>
    Se déconnecter
  </div>
  <!-- <ngx-simplebar data-simplebar-auto-hide="true"> -->
  <ngx-simplebar>
    <ul class="menu_drawer">
      <div *ngFor="let md of menu">
        <ng-container
          *ngIf="md.visibilityFlag && md.menuType != 'Lien Externe Navigateur' && md.menuType != 'PDF' && md.menuType != 'Application Mobile'">
          <li (click)="getLink(md.menuType, md.lien, md.url, md.addPersona, md.addFonction, md.title_Home)">
            <div class="menu_drawer_img">
              <app-img-icone [src]="md.svg_White"></app-img-icone>
            </div>
            <div class="menu_drawer_title">
              {{md.title_Drawer}}</div>
          </li>
        </ng-container>
        <ng-container *ngIf="md.visibilityFlag && md.menuType == 'Application Mobile'">
          <li (click)="invokeAppAction(md.url)">
            <div class="menu_drawer_img">
              <app-img-icone [src]="md.svg_White"></app-img-icone>
            </div>
            <div class="menu_drawer_title">
              {{md.title_Drawer}}</div>
          </li>
        </ng-container>
        <ng-container *ngIf="md.visibilityFlag && md.menuType == 'Lien Externe Navigateur' || md.menuType == 'PDF'">
          <a [href]="md.url">
            <li>
              <div class="menu_drawer_img">
                <app-img-icone [src]="md.svg_White"></app-img-icone>
              </div>
              <div class="menu_drawer_title">
                {{md.title_Drawer}}</div>
            </li>
          </a>
        </ng-container>
      </div>
    </ul>
  </ngx-simplebar>
  <!-- </ngx-simplebar> -->
</div>